export const environment = {
  production: true,
  envName: 'prod',
  apiUrl: 'https://apprex.gast.de/gast-service-auth/api/public/',
};
